import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import { FaHistory, FaShareAlt, FaQuestionCircle } from "react-icons/fa"; // Keep relevant icons
import { MdHome } from "react-icons/md";
import { AuthContext } from '../context/AuthContext'; // Adjust path if needed
import styles from '../assets/css/Dashboard.module.css'; // Import NEW CSS Module

function Footer() {
  const { WhastappMessage } = useContext(AuthContext);
  const location = useLocation(); // Get current location

  // Check login status
  const isLoggedIn = !!localStorage.getItem('login');

  const handleShare = async (event) => {
    event.preventDefault(); // Prevent default Link behavior
    if (!WhastappMessage) {
        console.error("Share function not available.");
        // Optionally show toast message
        return;
    }
    const messageUrl = await WhastappMessage();
    if (messageUrl) {
      window.location.href = messageUrl; // Use href for mobile
    } else {
      console.error("Could not get WhatsApp message URL.");
    }
  };

  // Helper function to determine if a link is active
  const isActive = (path) => location.pathname === path || (path === '/history/all' && location.pathname.startsWith('/history'));

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerTab}>
        {/* Home Button */}
        <Link
          to='/dashboard'
          className={`${styles.footerBtnContainer} ${isActive('/dashboard') ? styles.active : ''}`}
          aria-label="Home"
        >
          <MdHome className={styles.icon} />
          <p className={styles.label}>होम</p>
        </Link>

        {/* History Button (Conditional) */}
        {isLoggedIn && (
          <Link
            to='/history/all'
            className={`${styles.footerBtnContainer} ${isActive('/history/all') ? styles.active : ''}`}
            aria-label="History"
          >
            <FaHistory className={styles.icon} />
            <p className={styles.label}>हिस्ट्री</p>
          </Link>
        )}

        {/* Share Button (Conditional) */}
        {isLoggedIn && (
          <Link
            to="#" // Link to '#' as it triggers an action
            onClick={handleShare}
            className={styles.footerBtnContainer}
            aria-label="Share"
          >
            <FaShareAlt className={styles.icon} />
            <p className={styles.label}>शेयर</p>
          </Link>
        )}

        {/* Help/Login Button */}
        <Link
          to={isLoggedIn ? '/help' : '/login'} // Assuming '/help' is your contact page route
          className={`${styles.footerBtnContainer} ${isActive('/help') || isActive('/login') ? styles.active : ''}`}
          aria-label={isLoggedIn ? 'मदद' : 'Login'}
        >
          {/* Using React Icon */}
          <FaQuestionCircle className={styles.icon} />
          <p className={styles.label}>{isLoggedIn ? 'मदद' : 'Login'}</p>
        </Link>
      </div>
    </div>
  );
}

export default Footer;
